import { requestOrder, requestPromptBuilder } from 'utils/request';
import { JOB_ORDERS, JOB_ORDERS_FALLBACK, PROMPT_BUILDER } from './_paths';
import { auth } from 'utils/config/firebase';

export const reqGetStreamingData = async (stream_url: string, signal: AbortSignal) => {
    const id_token = await auth?.currentUser?.getIdToken();
    if (id_token) {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + id_token,
        };
        return fetch(stream_url, { headers, signal });
    }
    throw new Error();
};

export const reqGetJob = <T>(data: T) => {
    return requestPromptBuilder.post(`${PROMPT_BUILDER}/v2/prompt`, data);
};

export const reqStopGenerating = (conversation_id: string, message_id: string) => {
    return requestPromptBuilder.put(
        `${PROMPT_BUILDER}/v1/stream/${conversation_id}/${message_id}/stop`,
    );
};

export const reqShareDocs = (title: string, content: string) => {
    return requestPromptBuilder.post(`${PROMPT_BUILDER}/v2/share/google-docs`, {
        title,
        content,
    });
};

export const reqOAuthGoogle = (auth_code: string) => {
    return requestPromptBuilder.post(`${PROMPT_BUILDER}/v2/oauth/google`, {
        auth_code,
    });
};

export const reqEditText = (body: {
    conversation_id: string;
    message_id: string;
    prompt: string;
    marked_html: string;
}) => {
    return requestPromptBuilder.post(`${PROMPT_BUILDER}/v2/edit-text`, { ...body });
};

export const reqGetOrder = async (id: string) => {
    try {
        return await requestOrder(`${JOB_ORDERS}/${id}`);
    } catch {
        // Try fallback if main request fails
        return requestOrder(`${JOB_ORDERS_FALLBACK}/${id}`);
    }
};
